import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Logo from 'components/Logo'
import Paper from 'components/Paper'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'

import classes from './Compare.module.scss'

/** @type {import('./types').default} */
const Compare = ({ listings, className, ...props }) => {
  const [main, alter] = listings
  const { isCypressTakingSnapshots } = useAppContext()

  return (
    <Paper className={clsx('Compare', classes.root, classes.centered, className)} {...props}>
      <div className={clsx(classes.logos, classes.centered)}>
        {isCypressTakingSnapshots ? (
          <div className={classes.blackOut} />
        ) : (
          <Logo src={main.logo_url} alt={`${main.name} logo`} className={classes.main} loading="lazy" />
        )}
        <Icon icon="compare" prefix="ga" className={classes.compareIcon} />
        {isCypressTakingSnapshots ? (
          <div className={classes.blackOut} />
        ) : (
          <Logo className={classes.alter} src={alter.logo_url} alt={`${alter.name} logo`} loading="lazy" />
        )}
      </div>
      <Typography component="div" variant="body-xs" className={clsx(classes.centered)}>
        <span className={classes.main}>{main.name}</span>
        <span className={classes.vs}>vs</span>
        <span className={classes.alter}>{alter.name}</span>
      </Typography>
    </Paper>
  )
}

export default Compare
